export enum ETextSize {
  XS = `xs`,
  SM = `sm`,
  MD = `md`,
  LG = `lg`,
  XL = `xl`,
}

export enum EToggleSize {
  MD = `md`,
  SM = `sm`,
  XS = `xs`,
}

export enum ELanguage {
  CS = `cs`,
  DE = `de`,
  EN = `en`,
  ES = `es`,
  FR = `fr`,
  HU = `hu`,
  IT = `it`,
  NL = `nl`,
  PL = `pl`,
  PT = `pt`,
  SK = `sk`,
}

// https://github.com/locize/locizer#init-options
export enum ELocizeOrder {
  COOKIE = `cookie`,
  HTMLTAG = `htmlTag`,
  LOCALSTORAGE = `localStorage`,
  NAVIGATOR = `navigator`,
  QUERYSTRING = `querystring`,
}

export enum ECookie {
  LANGUAGE = `rin-language`,
}
